/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Reentrancy guard states */
export enum ReentrancyState {
  Unlocked,
  Locked,
}

export type ReentrancyStateArgs = ReentrancyState;

export function getReentrancyStateEncoder(): FixedSizeEncoder<ReentrancyStateArgs> {
  return getEnumEncoder(ReentrancyState);
}

export function getReentrancyStateDecoder(): FixedSizeDecoder<ReentrancyState> {
  return getEnumDecoder(ReentrancyState);
}

export function getReentrancyStateCodec(): FixedSizeCodec<
  ReentrancyStateArgs,
  ReentrancyState
> {
  return combineCodec(getReentrancyStateEncoder(), getReentrancyStateDecoder());
}
